import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=17239050&"
import script from "./NavItem.vue?vue&type=script&lang=ts&"
export * from "./NavItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports